import { tokenize } from 'linkifyjs'

export interface TrechoDeTexto {
	texto: string
	href?: string
}

interface Token {
	type: string
	toString(): string
	toHref(): string
}

const PROTOCOLOS_SEGUROS = new Set(['http:', 'https:'])

function hrefSeguro(href: string): string | undefined {
	try {
		return PROTOCOLOS_SEGUROS.has(new URL(href).protocol) ? href : undefined
	} catch {
		return undefined
	}
}

export function separarLinks(texto?: string | null): TrechoDeTexto[] {
	if (!texto) return []
	return (tokenize(texto) as unknown as Token[]).map(token => ({
		texto: token.toString(),
		href: token.type === 'url' ? hrefSeguro(token.toHref()) : undefined,
	}))
}
